import React, { useEffect, useRef, useState } from 'react';
import { apiConfiguration } from '../../apiConfig';

export default function Info() {
  const apiUrl = process.env.REACT_APP_API_URL ?? process.env.PUBLIC_URL;
  const publicUrl = process.env.PUBLIC_URL;
  const appVersion = process.env.REACT_APP_VERSION;
  const [apiVersion, setApiVersion] = useState<String>();

  useEffect(() => {
    const fetchData = async () => {
      // var api = new UtilitiesApi(apiConfiguration);

      // setApiVersion(await api.getVersion());
    };

    fetchData()
      // make sure to catch any error
      .catch(console.error);
  }, []);

  return (
    <React.Fragment>
      <h2 className={'content-block'}>Info</h2>
      <div className={'content-block'}>
        <div className={'dx-card responsive-paddings'}>
          <p>API URL: {apiUrl}</p>
          <p>PUBLIC URL: {publicUrl}</p>
          <p></p>
          <p>APP VERSION: {appVersion}</p>
          <p>API VERSION: {apiVersion}</p>
        </div>
      </div>
    </React.Fragment>
  )
}